import { render, staticRenderFns } from "./BaseAdmMaster.vue?vue&type=template&id=2aef3b48&scoped=true&"
import script from "./BaseAdmMaster.vue?vue&type=script&lang=js&"
export * from "./BaseAdmMaster.vue?vue&type=script&lang=js&"
import style0 from "./BaseAdmMaster.vue?vue&type=style&index=0&id=2aef3b48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aef3b48",
  null
  
)

export default component.exports